import { TCommonDealDetailKeys } from '../../types/promoInfo';

/**
 * Утилита служит для формирования строки-ссылки с якорем на модалку,
 * которую затем можно использовать прямо в тексте.
 *
 * Вызов модалки нужно делать отдельно. Для идентификации на всех таких ссылках есть атрибут data-modal-link.
 */
export const makeModalTextLink = (modalId: TCommonDealDetailKeys, text: string) => {
  return `<a role="button" href="#${modalId}" data-modal-link="true">${text}</a>`;
};
